import dayjs from "dayjs"
export default {
  props: {
    tracking: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    link() {
      let link = this.item.link

      if (this.search?.dateTo && this.search?.dateFrom) {
        let period = dayjs(this.search.dateTo).diff(this.search.dateFrom, "days")
        link += "?bookingdate=" + dayjs(this.search.dateFrom).format("YYYY-MM-D") + "&period=" + period
      } else if (this.search?.date) {
        link += "?bookingdate=" + dayjs(this.search.date).format("YYYY-MM-D")
      }

      if (this.search?.adults) {
        link += `&adults=${this.search.adults}`
      }

      if (this.search?.children) {
        link += `&children=${this.search.children}`
      }

      if (this.tracking) {
        link +=
          (!link.includes("?") ? "?" : "") +
          `utm_campaign=Member+campaign&utm_source=internal&utm_medium=banner&utm_content=${this.item.title}&utm_term=${this.item.id}`
      }

      return link
    },
  },
}
